<template>
    <div class="right_icons_box"> 
        <!-- md  -->
        <div class="md_box" @click="openmd">
            <div class="font_line">关</div>
            <div class="font_line">注</div>
            <div class="font_line">我</div>
            <div class="font_line">们</div>
        </div>
      
       <el-dialog
            append-to-body
            :show-close="false"
            :visible.sync="dialogVisible"
            width="70%">
            <div class="contact_box">
                <div class="contact_content">
                    <div class="contact_title">公司二维码</div>
                    <img class="contact_img" src="../../../assets/icons/官网首页_slices/erweima.png" alt="">
                </div>
                 <div class="contact_content">
                    <div class="contact_phone_title">公司联系电话</div>
                    <div class="contact_phone">173-5451-6359</div>
                </div>
            </div>
            <div class="close_box" @click="closemd">
               <img src="../../../assets/icons/官网首页_slices/close.png" alt=""> 
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            compony:{},
            dialogVisible:false,
        }
    },
    methods:{
        openmd(){
            this.dialogVisible=true;
        },
        closemd(){
            this.dialogVisible=false;
        },
    },
}
</script>
<style lang="less" scoped>
    /deep/.el-dialog__header {
        padding:0px 0px;
    }
    /deep/.el-dialog__body{
        position: relative;
        .close_box{
            width: 70px;
            height: 70px;
            background: #FFFFFF;
            border-radius: 50%;
            position: absolute;
            bottom: -15%;
            left: 45%;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                width: 28px;    
                height: 28px;
            }
        }
    }
    .contact_box{
        .contact_content{
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .contact_phone{
                font-weight: 500;
                font-size: 36px;
                color: #027DFC;
                margin-bottom: 50px;
            }
            .contact_phone_title{
                font-weight: 400;
                font-size: 36px;
                color: #606060;
                margin-bottom: 20px;
                margin-top: 40px;
            }
            .contact_title{
                font-weight: 400;
                font-size: 36px;
                color: #606060;
                margin-top: 40px;
                margin-bottom: 20px;
            }
            .contact_img{
                width: 350px;
                height: 350px;
            }
        }
    }
    .right_icons_box{   
        position: fixed;
        z-index: 8;
        top: 590px;
        right: 0px;
        .md_box{
            writing-mode: vertical-rl;
            text-orientation: upright;
            display: flex;
            justify-content: space-around; 
            box-sizing: border-box;
            padding: 23px 0px;
            align-items: center;
            height: 170px; 
            width: 65px;
            background: #027DFC;
            border-top-left-radius: 22px;
            border-bottom-left-radius: 22px;
            font-size: 23px;
            font-weight: 400;
            color: #FFFFFF;
            // .font_line{
            //     // height: 10px;
            // }
        }
        .right_icons{
            display: none;
        }
     
        // border-top-left-radius: 12px;
        // border-bottom-left-radius: 12px;
        // border-top: 5px solid black;
        // border-left: 5px solid black;
        // border-bottom: 5px solid black;
    }

</style>